module.exports = __webpack_public_path__ + "img/logo_tomotek.9ba5678b.png";